import { z } from 'zod'

const PaginationParamsSchema = z.object({
  page: z.string().min(1).optional(),
  search: z.string().min(1).optional(),
})

const PaginationSchema = z.object({
  meta: z.object({
    current_page: z.number(),
    last_page: z.number(),
    total: z.number(),
  }),
})

export { PaginationParamsSchema, PaginationSchema }
